import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getPatientCAAMetricsMonthQueryKey(
  patientId: string,
  {
    personaName,
    month,
    year
  }: { personaName?: string; month: number; year: number }
) {
  return ['patientCAAMetricsMonth', patientId, { personaName, month, year }]
}

export function usePatientCAAMetricsMonthQuery({
  patientId,
  personaName,
  month,
  year,
  enabled
}: {
  patientId: string
  personaName?: string
  month: number
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getPatientCAAMetricsMonthQueryKey(patientId, {
      personaName,
      month,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getPatientCAAMetricsMonth({
        patientId,
        personaName,
        month,
        year
      }),
    enabled
  })
}
